var InformationButtonView = (function (BaseView, getPageTemplate) {
	return BaseView.extend({
		className: 'information-button hidden',

		hiddenClass: 'hidden',

		events: {
			'click a': '_onClick'
		},

		initialize: function (opts) {
			opts = opts || {};
			this._templates = _.extend({
				link: null,
				info: null
			}, opts.templates);
			this.render();
		},

		render: function () {
			this.$el.html($('<a>').addClass('decor-link').html(getPageTemplate(this._templates.link)));

			if (this._hasText()) {
				this.$el.removeClass(this.hiddenClass);
			} else {
				this.$el.addClass(this.hiddenClass);
			}

			return this;
		},

		_hasText: function () {
			if ($.f.hasOwnProperty(this._templates.info)) {
				return !!$.f[this._templates.info];
			} 
			return false;			
		},

		_getText: function () {
			if ($.f.hasOwnProperty(this._templates.info)) {
				return getPageTemplate(this._templates.info);
			} else {
				return null;
			}
		},

		_onClick: function (e) {
			e.preventDefault();
			this.display('checkout.information', {
				htmlToRender: this._getText()
			});
		}
	});
})(BaseView, kos.getPageTemplate);
